import { intl } from 'lang/intl'

export default function getSearchContext(key, object) {
  if (key === 'all:video') {
    return {
      key: 'all:video',
      data: { prioritize_promoted_p: 1 },
      // eslint-disable-next-line
      selectable: this.props.searchIn.indexOf('photos') > -1,
      object: {
        object_type: 'site',
        title: intl.formatMessage({ defaultMessage: 'All videos' }),
        // eslint-disable-next-line
        selectable: this.props.searchIn.indexOf('site') > -1,
        key: 'site:photos',
      },
    }
  }
  if (key === 'all:live') {
    return {
      key: 'all:live',
      data: {},
      // eslint-disable-next-line
      selectable: this.props.searchIn.indexOf('live') > -1,
      object: {
        object_type: 'site',
        title: intl.formatMessage({ defaultMessage: 'All live events' }),
        // eslint-disable-next-line
        selectable: this.props.searchIn.indexOf('site') > -1,
        key: 'site:live',
      },
    }
  }
  if (key === 'all:video:recent') {
    return {
      key: 'all:video:recent',
      data: {
        orderby: 'created',
        prioritize_promoted_p: 0,
      },
      // eslint-disable-next-line
      selectable: this.props.searchIn.indexOf('photos') > -1,
      object: {
        title: intl.formatMessage({ defaultMessage: 'Most recent videos' }),
        selectable: false,
      },
    }
  }
  if (key === 'all:video:views') {
    return {
      key: 'all:video:views',
      data: {
        orderby: 'views',
        order: 'desc',
        prioritize_promoted_p: 0,
      },
      // eslint-disable-next-line
      selectable: this.props.searchIn.indexOf('photos') > -1,
      object: {
        title: intl.formatMessage({ defaultMessage: 'Most viewed videos' }),
        selectable: false,
      },
    }
  }
  if (/album:/.test(key)) {
    return {
      key,
      data: { album_id: object.album_id },
      // eslint-disable-next-line
      selectable: this.props.searchIn.indexOf('photos') > -1,
      object: {
        object_type: 'album',
        title: object.title,
        // eslint-disable-next-line
        selectable: this.props.searchIn.indexOf('albums') > -1,
        key,
      },
    }
  }
  if (/live:/.test(key)) {
    return {
      key,
      data: { live_id: object.live_id },
      // eslint-disable-next-line
      selectable: this.props.searchIn.indexOf('photos') > -1,
      object: {
        ...object,
        object_type: 'live',
        title: object.name,
        // eslint-disable-next-line
        selectable: this.props.searchIn.indexOf('live') > -1,
        key,
      },
    }
  }
  if (key === 'social:facebook') {
    return {
      key,
      data: { sync_platform: 'facebook' },
      // eslint-disable-next-line
      selectable: this.props.searchIn.indexOf('photos') > -1,
      object: {
        title: intl.formatMessage(
          {
            defaultMessage: 'Videos on {platform}',
          },
          { platform: 'Facebook' }
        ),
        selectable: false,
      },
    }
  }
  if (key === 'social:twitter') {
    return {
      key,
      data: { sync_platform: 'twitter' },
      // eslint-disable-next-line
      selectable: this.props.searchIn.indexOf('photos') > -1,
      object: {
        title: intl.formatMessage(
          { defaultMessage: 'Videos on {platform}' },
          { platform: 'Twitter' }
        ),
        selectable: false,
      },
    }
  }
  if (key === 'social:youtube') {
    return {
      key,
      data: { sync_platform: 'youtube' },
      // eslint-disable-next-line
      selectable: this.props.searchIn.indexOf('photos') > -1,
      object: {
        title: intl.formatMessage(
          { defaultMessage: 'Videos on {platform}' },
          { platform: 'YouTube' }
        ),
        selectable: false,
      },
    }
  }
  if (key === 'social:vimeo') {
    return {
      key,
      data: { sync_platform: 'vimeo' },
      // eslint-disable-next-line
      selectable: this.props.searchIn.indexOf('photos') > -1,
      object: {
        title: intl.formatMessage(
          { defaultMessage: 'Videos on {platform}' },
          { platform: 'Vimeo' }
        ),
        selectable: false,
      },
    }
  }
  return null
}
